import styled from 'styled-components';
import { customMedia } from 'styles/utils';

const blockSize = '5.5rem';

export const MainShareCardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: ${blockSize};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  margin: 0;
  transition: background 0.1s linear;
  &:hover {
    background: ${props => props.theme.color.wfGrey100};
  }
`;

export const ImageWrapper = styled.div`
  width: ${blockSize};
  height: 100%;
  border-right: ${props =>
    props.noBorder ? 'none' : `1px solid ${props.theme.color.wfGrey300}`};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const MainRowWrapper = styled.div`
  padding: ${props => props.theme.space[2]} ${props => props.theme.space[3]};
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.around ? 'space-around' : 'space-between'};
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ColumnBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: ${blockSize};
  padding: ${props => (props.removePadding ? '0' : '0 1rem')};
`;

export const UserColumnBlock = styled(ColumnBlock)`
  min-width: 14rem;
  max-width: 14rem;
  padding-right: ${props => props.theme.space[2]};
  padding-left: 0;

  > a {
    > h3:hover {
      color: ${props => props.theme.color.wfBlue};
    }
  }

  ${customMedia.lessThan('large')`
    min-width: 10rem;
    max-width: 10rem;
  `};
`;

export const DateBlockWrapper = styled(ColumnBlock)`
  time {
    color: ${props => props.theme.color.wfGrey500};
  }

  ${customMedia.lessThan('large')`
    display: none;
  `};
`;

export const ActionsWrapper = styled.div`
  opacity: ${props => (props.isVisible ? 1 : 0)};
  display: flex;
  justify-content: center;
  align-items: center;
  // min-width: ${blockSize};
  height: 100%;

  & > * {
    margin-right: 1em;
  }
`;
